import HorizontalListView from "../../../_utils/horizontal-list-view/HorizontalListView";
import {useContext} from "react";
import QRCodeStyleViewContext from "../../../QRCodeStyleViewContext";

/**
 * Dots component to be used on IndexView
 * @author Kacper Faber
 * @since 0.1.9
 */
function DotsComponent() {
    /**
     *
     * @author Kacper Faber
     * @since 0.1.9
     */
    const {setActiveView} = useContext(QRCodeStyleViewContext);

    /**
     * On more button is clicked
     * @author Kacper Faber
     * @since 0.1.9
     */
    const onMoreButtonClick = () => {
        setActiveView('more-dots');
    };

    return (
        <HorizontalListView
            label="STYL KODU"
            onMoreButtonClick={onMoreButtonClick}
            moreButton="WIĘCEJ USTAWIEŃ"
        />
    );
}

export default DotsComponent;